import styled from "styled-components";
import { i18n } from "../../../services/i18nService";

export const VideoCommerceContainerStyled = styled.div`
  position: absolute;
  width: 98%;
  bottom: 0;
  opacity: 1;
  z-index: 11;
  color: #ffffff;
`;

export const VideoCommerceListContainerStyled = styled.div``;
export const BackIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const BackIconStyled = styled.div`
  box-sizing: border-box;
  border: 2px solid rgba(${props => props.theme.color.greyRGB}, 0.24);
  background-color: ${props => props.theme.color.primary};
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.3125rem 0rem 0rem 0.6125rem;
`;
export const ListControlsContainerStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 4rem;
`;

export const CloseIconTextStyled = styled.div`
  ${props => ` 
  margin: 0rem 0.8rem;
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: ${props.theme.font.weight.bold};
  letter-spacing: 0;
  line-height: 1.25rem;`}
`;
